ui-cms-flipcard {
  display: block;

  &.front-col-reverse sd-flipcard::part(front),
  &.back-col-reverse sd-flipcard::part(back) {
    flex-direction: column-reverse;
  }

  sd-flipcard {
    width: 100%;
    height: 100%;

    &.aspect-landscape {
      aspect-ratio: 16 / 9;
      height: auto;
    }
  }

  .flipcard {
    &__content {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: $sd-spacing-3;
      padding: $sd-spacing-3 $sd-spacing-5 $sd-spacing-5;

      .leadtext {
        font-size: $sd-fontSize-base;
      }
    }

    &__image {
      height: 100%;

      img {
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
